import { Component } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-admin-nav',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './admin-nav.html',
  styleUrl: './admin-nav.scss',
})
export class AdminNav {
  readonly navItems = [
    { path: '/statistics', label: 'Estadísticas', icon: 'chart' },
    { path: '/notifications-admin', label: 'Notificaciones', icon: 'bell' },
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async logout() {
    await this.authService.logout();
    this.router.navigate(['/login']);
  }
}
